<!-- currently hides "separator" items in button-big style menu-->
<!-- TODO use styling to differentiate between separators and actual menu items instead of *ngIf?-->
<!-- Implement small pill style menu-->

<!--TileBig-->
<ng-container *ngIf="dsMenu && dsMenu.objectNode && dsMenu.objectNode.Menu_Item">
  <div *ngIf="layout == MenuLayoutType.TileBig" [class]="columnClass ? 'row' : 'btn-group'">
    <div
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="tilebigcontextmenu"
      [style.display]="menuitem.Type == 'separator' ? separatorDisplay : columnClass ? '' : 'block'"
      [class]="columnClass ? columnClass : ''"
    >
      <aurora-button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [class.disabled]="checkDisabled(menuitem)"
        variant="ghost"
      >
        {{ menuitem.Label }}
      </aurora-button>
      <div
        *ngIf="menuitem.Type == 'separator'"
        style="font-weight: 800; font-size: 1.3em"
        [style.color]="separator == 'inline' ? 'white' : 'darkslategrey'"
        [style.transform]="separator == 'inline' ? 'rotate(300deg)' : null"
      >
        <span>
          {{ menuitem.Label }}
        </span>
      </div>
      <multi-tab-context-menu #tilebigcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--TileSmall-->
  <div class="btn-group" *ngIf="layout == MenuLayoutType.TileSmall">
    <div
      style="display: inline-block"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="tilesmallcontextmenu"
    >
      <a
        *ngIf="validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        [class]="'btn btn-app ' + color(menuitem)"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [style.min-width]="menuitem.Type == 'separator' ? '0px' : '47px'"
        style="
          height: 47px;
          margin-top: -1px;
          margin-bottom: 0;
          border-radius: 0px;
          margin-left: 0px;
          margin-right: -1px;
          cursor: pointer;
          position: relative;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <i [class]="menuitem.Icon" style="font-size: 20px"></i>
      </a>
      <multi-tab-context-menu #tilesmallcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Sidebar-->
  <div
    *ngIf="layout == MenuLayoutType.Sidebar"
    class="sidebar sm-card"
    style="padding: var(--aurora-spacing-02) var(--aurora-spacing-06)"
  >
    <div
      [class]="menuitem.Type == 'separator' ? 'py-2' : 'pb-1'"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [class.header]="menuitem.Type == 'separator'"
      [style.font]="menuitem.Type == 'separator' ? 'var(--aurora-font-headline-small)' : ''"
      [style.color]="menuitem.Type == 'separator' ? 'var(--aurora-semantic-foreground-neutral-primary)' : ''"
      [multiTabContextMenuTrigger]="sidebarcontextmenu"
    >
      <aurora-button
        *ngIf="!(menuitem.Type && menuitem.Type == 'separator') && validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        style="cursor: pointer"
        [disabled]="checkDisabled(menuitem)"
        variant="ghost"
      >
        <ng-template #menuItemTooltipContent>
          <div *ngIf="menuitem.Tooltip">{{ menuitem.Tooltip }}</div>
          <div *ngIf="!menuitem.Tooltip">{{ menuitem.Label }}</div>
          <div *ngIf="menuitem.Flag">
            <table style="font-size: 12px; color: white">
              <tr *ngFor="let flag of menuitem.Flag">
                <td>{{ flag.Tooltip }}</td>
              </tr>
            </table>
          </div>
        </ng-template>
        <span>{{ menuitem.Label }}</span>
        <aurora-badge *ngIf="menuitem.Badge" type="count" prominence="low" color="default" class="ms-2">
          {{ menuitem.Badge }}
        </aurora-badge>
        <!-- <span *ngIf="menuitem.Flag">
            <i *ngFor="let flag of menuitem.Flag" [class]="'fa ' + flag.Icon" style="margin-left: 5px"></i>
          </span> -->
      </aurora-button>
      <span *ngIf="menuitem.Type == 'separator'" style="text-transform: uppercase">{{ menuitem.Label }}</span>
      <multi-tab-context-menu #sidebarcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Hyperlink-->
  <div *ngIf="layout == MenuLayoutType.Hyperlink" [class]="columnClass ? 'row' : ''">
    <div
      [style]="columnClass ? '' : 'display: inline-flex; gap: 0.75em'"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="hyperlinkcontextmenu"
      [class]="columnClass ? columnClass : ''"
    >
      <aurora-link-button
        *ngIf="validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        [size]="menuitem.Color == 'on_dark' ? 'large' : 'small'"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        title=""
        (click)="runAction(menuitem)"
        [disabled]="checkDisabled(menuitem)"
      >
        {{ menuitem.Label }}
        <aurora-badge *ngIf="menuitem.Badge" type="count" prominence="low" color="info" class="ms-2">
          {{ menuitem.Badge }}
        </aurora-badge>
      </aurora-link-button>
      <multi-tab-context-menu #hyperlinkcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Toolbar-->
  <div
    class="ms-1"
    *ngIf="layout == MenuLayoutType.Toolbar"
    style="display: flex; column-gap: 2px; align-items: center"
  >
    <ng-container
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="toolbarcontextmenu"
    >
      <aurora-button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator' && menuitem.Type != 'dropdownMenu'"
        [variant]="menuitem.ShowButtonLabel ? auroraVariant(menuitem) : 'ghost'"
        (click)="runAction(menuitem)"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        [manualID]="buildIDAttribute(menuitem)"
        [loading]="checkLoading(menuitem)"
        [disabled]="checkDisabled(menuitem)"
      >
        <i
          *ngIf="!menuitem.ShowButtonLabel && !auroraIconName(menuitem.Icon)"
          [class]="'fa fw ' + menuitem.Icon"
        ></i>
        <aurora-icon
          *ngIf="!menuitem.ShowButtonLabel && auroraIconName(menuitem.Icon)"
          [icon]="auroraIconName(menuitem.Icon)"
        ></aurora-icon>
        {{ menuitem.ShowButtonLabel == true ? menuitem.Label : null }}
      </aurora-button>

      <div
        *ngIf="
          validMenuItem(menuitem) &&
          menuitem.Type == 'dropdownMenu' &&
          menuitem.DropDownMenuItems &&
          menuitem.DropDownMenuItems.length > 0
        "
        ngbDropdown
        placement="bottom-right"
        [autoClose]="true"
      >
        <aurora-icon-button
          type="button"
          ngbDropdownToggle
          [icon]="auroraIconName(menuitem.Icon)"
          [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        ></aurora-icon-button>
        <div ngbDropdownMenu class="unity-menu dropdown">
          <ul>
            <ng-container *ngFor="let dropdownMenuItem of menuitem.DropDownMenuItems">
              <li ngbDropdownItem *ngIf="validMenuItem(dropdownMenuItem)">
                <aurora-button type="button" (click)="runAction(dropdownMenuItem)" block variant="secondary">
                  <span class="label">{{ dropdownMenuItem.Label }}</span>
                </aurora-button>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>

      <multi-tab-context-menu #toolbarcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </ng-container>
  </div>

  <div
    class="btn-group"
    *ngIf="layout == MenuLayoutType.TileText"
    style="width: 100%; background-color: blanchedalmond"
  >
    <ng-container *ngFor="let menuitem of dsMenu.objectNode.Menu_Item">
      <button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        [class]="'btn btn-app ' + color(menuitem)"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        [style.min-width]="menuitem.Type == 'separator' ? '0px' : '77px'"
        [style.max-width]="menuitem.Type == 'separator' ? '0px' : '77px'"
        style="
          height: 79px;
          margin-top: -1px;
          margin-bottom: 0;
          border-radius: 0px;
          margin-left: 0px;
          margin-right: -1px;
          cursor: pointer;
          background-color: floralwhite;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 12px; white-space: pre-line; vertical-align: middle">{{ menuitem.Label }}</div>
        <aurora-badge
          *ngIf="menuitem.Badge"
          type="count"
          prominence="low"
          color="info"
          class="ms-2"
          style="top: 60px; right: 4px"
        >
          {{ menuitem.Badge }}
        </aurora-badge>
      </button>
      <div
        *ngIf="validMenuItem(menuitem) && menuitem.Type == 'separator'"
        style="
          height: 25px;
          width: 100%;
          font-weight: 600;
          background-color: var(--aurora-semantic-surface-base-neutral-standard);
          border-bottom: 1px solid var(--aurora-primitive-gray-020);
          color: var(--aurora-semantic-foreground-neutral-primary);
          display: block;
          padding: 4px;
          text-transform: uppercase;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 12px; white-space: pre-line; vertical-align: middle">{{ menuitem.Label }}</div>
      </div>
    </ng-container>
  </div>
  <!-- HACK 52e7ef7e-5f9e-48d6-9a06-67c4fb748645
       10/9/2021  Hack to add support to "Text" Menu type  (see other changed on action-menu component  -->
  <div class="btn-group" *ngIf="layout == MenuLayoutType.Text" style="width: 100%; background-color: whitesmoke">
    <ng-container *ngFor="let menuitem of dsMenu.objectNode.Menu_Item">
      <button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        [class]="'btn btn-menu-text'"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [title]="menuitem.Tooltip"
        style="
          height: 20px;
          margin-top: 0;
          margin-bottom: 0;
          margin-left: 0px;
          margin-right: 12px;
          cursor: pointer;
          border: none;
          padding: 2px 2px 2px 2px;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 13px; white-space: pre-line; vertical-align: middle">
          {{ menuitem.Label.toUpperCase() }}
        </div>
        <aurora-badge
          *ngIf="menuitem.Badge"
          type="count"
          prominence="low"
          color="info"
          class="ms-2"
          style="top: 60px; right: 4px"
        >
          {{ menuitem.Badge }}
        </aurora-badge>
      </button>
    </ng-container>
  </div>
  <!-- END HACK 52e7ef7e-5f9e-48d6-9a06-67c4fb748645 -->

  <!---Prototype for cascading launch menu ----->
  <!--Cascade -->
  <div *ngIf="layout == MenuLayoutType.Cascade" class="prototypeMenuCascade">
    <div *ngFor="let menuSection of cascadeMenu" class="menu-header">
      <span
        *ngIf="menuSection.Child_Menu_Item && menuSection.Child_Menu_Item.length > 0"
        style="text-transform: uppercase"
        >{{ menuSection.Label }}</span
      >
      <div *ngFor="let menuitem of menuSection.Child_Menu_Item" [multiTabContextMenuTrigger]="cascadecontextmenu">
        <a
          *ngIf="!(menuitem.Type && menuitem.Type == 'separator') && validMenuItem(menuitem)"
          [manualID]="buildIDAttribute(menuitem)"
          (click)="runAction(menuitem)"
          [title]="menuItemTooltipContent"
          style="cursor: pointer"
          [class.disabled]="checkDisabled(menuitem)"
          class="menu-item"
        >
          <ng-template #menuItemTooltipContent>
            <div *ngIf="menuitem.Tooltip">{{ menuitem.Tooltip }}</div>
            <div *ngIf="!menuitem.Tooltip">{{ menuitem.Label }}</div>
            <div *ngIf="menuitem.Flag">
              <table style="font-size: 12px; color: white">
                <tr *ngFor="let flag of menuitem.Flag">
                  <td>{{ flag.Tooltip }}</td>
                </tr>
              </table>
            </div>
          </ng-template>
          <span>{{ menuitem.Label }}</span>
          <aurora-badge *ngIf="menuitem.Badge" type="count" prominence="low" color="info" class="ms-2">
            {{ menuitem.Badge }}
          </aurora-badge>

          <span *ngIf="menuitem.Flag">
            <i *ngFor="let flag of menuitem.Flag" [class]="'fa ' + flag.Icon" style="margin-left: 5px"></i>
          </span>
        </a>
        <multi-tab-context-menu #cascadecontextmenu>
          <a
            href="Javascript:;"
            name="NewTab"
            style="
              display: block;
              color: #ffffff;
              cursor: pointer;
              font-size: 14px;
              padding: 0px 10px 5px 10px;
              border-bottom: 1px solid;
            "
            (click)="runActionInNewTab($event, menuitem)"
            >Open in New Tab</a
          >
          <a
            href="Javascript:;"
            name="NewWindow"
            style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
            (click)="runActionInNewWindow($event, menuitem)"
            >Open in New Window</a
          >
        </multi-tab-context-menu>
      </div>
    </div>
    <!-- {{ cascadeMenu | json }} -->
  </div>
  <!---END Prototype for cascading launch menu ----->

  <!--Unity-->
  <nav class="unity-tabs small" *ngIf="layout == MenuLayoutType.Unity">
    <aurora-link-button
      *ngIf="isNotAuthenticated"
      disabled
      iconLeft="arrow-left"
      title="Cannot Go Back to Previous Page"
    >
      Back
    </aurora-link-button>
    <aurora-link-button size="small" iconLeft="arrow-left" (click)="goBack()" ngbTooltip="Go Back to Previous Page">
      Back
    </aurora-link-button>
    <ng-container
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="hyperlinkcontextmenu"
    >
      <a
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        class="unity-tab"
        [class.on]="menuitem.Url && pLocation._location.href.includes(menuitem.Url[0])"
        [manualID]="buildIDAttribute(menuitem)"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        (click)="runAction(menuitem)"
        [attr.disabled]="checkDisabled(menuitem)"
      >
        {{ menuitem.Label }}
        <aurora-badge *ngIf="menuitem.Badge" type="count" prominence="low" color="info">
          {{ menuitem.Badge }}
        </aurora-badge>
      </a>
      <multi-tab-context-menu #hyperlinkcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </ng-container>
  </nav>
</ng-container>
